import { handleActions } from 'redux-actions';
import { setUser, setAllUsers, cleanUser, updateUserStatus } from 'actions/user';
import { UserState } from '../types/global';

export const userInitialState: UserState = {
  id: null,
  email: null,
  firstName: null,
  lastName: null,
  role: null,
  token: null,
  success: null,
  status: null,
  addressInfo: {
    id: null,
    userId: null,
    address: null,
    country: null,
    city: null,
    province: null,
    postalCode: null,
  },
  info: {
    id: null,
    userId: null,
    companyName: null,
    contactPerson: null,
    contactPersonTitle: null,
    phoneNumber: null,
    companyBio: null,
  },
};

const allUsersInitialState: any = {};

export const user = handleActions(
  {
    [setUser as any]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [cleanUser as any]: () => userInitialState,
  },
  userInitialState
);

export const allUsers = handleActions(
  {
    [setAllUsers as any]: (_, action) => action.payload,
    [updateUserStatus as any]: (state, action) => {
      const { status, userId, userRole } = action.payload;
      return {
        ...state,
        [`${userRole.toLowerCase()}s`]: state[`${userRole.toLowerCase()}s`].map(
          (userWithRole: any) => {
            if (userWithRole.id === userId) {
              return { ...userWithRole, status };
            }
            return userWithRole;
          }
        ),
      };
    },
  },
  allUsersInitialState
);
